module.exports = __webpack_public_path__ + "static/img/tiktok-shop-v8.6673089.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/salepage/btn_marketplace/tiktok-shop-v8.gif
// module id = ywVj
// module chunks = 134